import { SessionStorageEnum } from "@/apps/merchant3/enums/sessionStorageEnum";

export const jsonHeader = (): Record<string, string> => {
  return {
    "Content-Type": "application/json",
  };
};

export const merchantJwtHeader = (): Record<string, string> => {
  let jwt: string | undefined = undefined;
  if (sessionStorage.getItem(SessionStorageEnum.MerchantJwt)) {
    jwt = sessionStorage.getItem(SessionStorageEnum.MerchantJwt) as string;
  }
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${jwt}`,
  };
};

export const clerkJwtHeader = (): Record<string, string> => {
  let jwt: string | undefined = undefined;
  if (sessionStorage.getItem(SessionStorageEnum.ClerkJwt)) {
    jwt = sessionStorage.getItem(SessionStorageEnum.ClerkJwt) as string;
  }
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${jwt}`,
  };
};

export const pmJwtHeader = (): Record<string, string> => {
  let jwt: string | undefined = undefined;
  if (sessionStorage.getItem("PJ_accessToken")) {
    jwt = sessionStorage.getItem("PJ_accessToken") as string;
  }
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${jwt}`,
  };
};

export const jwtHeader = (): Record<string, string> => {
  let jwt: string | undefined = undefined;
  if (sessionStorage.getItem("PJ_m3AccessToken")) {
    jwt = sessionStorage.getItem("PJ_m3AccessToken") as string;
  }
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${jwt}`,
  };
};

export const formDataHeader = (): Record<string, string> => {
  return {
    "Content-Type": "multipart/form-data",
  };
};
